import { UserModel } from "../Models/user.mode";
import { NotificationResponse } from "../Models/user.mode";
import request, { Method } from "../request";

interface userTokenResponse {
    user: UserModel;
    token: string;
    endpoint: string;
}

export interface ClockInData {
    clockIn: string | null;
    clockOut: string | null;
}

export interface Shift {
    totalSeconds: string;
    inShift: boolean;
    lastShift: string;
    served_rider: number | null;
}

class UserService {
    async login(email: string, password: string): Promise<userTokenResponse> {
        return request<userTokenResponse>(`/auth/login`, Method.POST, {
            data: {
                email: email,
                password: password,
            },
        });
    }

    async getCurrentUser() {
        return request<userTokenResponse>(`/auth/current-user`, Method.GET);
    }

    async logout() {
        return request(`/auth/logout`, Method.POST);
    }

    async getCookies() {
        return request(`/sanctum/csrf-cookie`, Method.GET, {}, false);
    }

    async changePassword(oldPassword: string, newPassword: string) {
        return request<userTokenResponse>(`/auth/change-password`, Method.POST, {
            data: {
                old_password: oldPassword,
                new_password: newPassword,
            },
        });
    }
    async notifications(lastFetchTime: string | null): Promise<NotificationResponse> {
        return request<NotificationResponse>(`/auth/notifications`, Method.POST, {
            lastFetchTime: lastFetchTime || null,
        });
    }

    async readNotification() {
        return request(`/auth/notification_read`, Method.GET);
    }

    async deleteNotification(id: number) {
        return request(`/auth/notification/${id}/delete`, Method.GET);
    }

    async getClockInData() {
        return request<ClockInData>(`/t-patroller/clock-in`, Method.POST);
    }

    async getClockOutData() {
        return request<ClockInData>(`/t-patroller/clock-out`, Method.POST);
    }

    async getSift() {
        return request<Shift>(`/t-patroller/shift`, Method.GET);
    }

    async resetPassword(password: string): Promise<any> {
        return request<userTokenResponse>(`/auth/reset-password`, Method.POST, {
            data: {
                password: password,
            },
        });
    }
}

export const userService = new UserService();
